document.addEventListener("DOMContentLoaded", function () {
  const updateDisplay = () => {
    $("#subscription").hide();
    $("#oneShootLetter").hide();
    $("#oneShootCard").hide();
    $(".offer-content-menu a").removeClass("active");

    setTimeout(() => {
      if (window.location.hash === "#subscription") {
        $("#subscription").show();
        $(".offer-content-menu a").eq(1).addClass("active");
      } else if (window.location.hash === "#oneShootLetter") {
        $("#oneShootLetter").show();
        $(".offer-content-menu a").eq(2).addClass("active");
      } else if (window.location.hash === "#oneShootCard") {
        $("#oneShootCard").show();
        $(".offer-content-menu a").eq(3).addClass("active");
      } else {
        $("#subscription").show();
        $("#oneShootLetter").show();
        $("#oneShootCard").show();
        $(".offer-content-menu a").eq(0).addClass("active");
      }
    }, 100);
  };

  updateDisplay();

  $('[data-offer="change"]').on("click", updateDisplay);

  if (isMobile()) {
    const cardTable = $("#oneShootCard");
    const content = cardTable.find("tr").eq(0).find("th").eq(0).text();
    cardTable.find("tr").eq(0).find("th").eq(0).remove();
    cardTable.find("tr").eq(1).find("td").eq(0).text(content);
    cardTable
      .find("tr")
      .eq(0)
      .find("th")
      .eq(0)
      .css({ padding: 0, width: "50%" })
      .attr("colspan", 1);
    cardTable
      .find("tr")
      .eq(0)
      .find("th")
      .eq(1)
      .css({ padding: 0, width: "50%" });

    const showNormal = () => {
      cardTable.find("tr").each(function () {
        cardTable.find("tr").eq(0).find("th").eq(0).css({ opacity: 1 });
        cardTable.find("tr").eq(0).find("th").eq(1).css({ opacity: 0.2 });
        $(this).find("td").hide();
        $(this).find("td").eq(0).show();
        $(this).find("td").eq(1).show();
        $(this).find("td").eq(2).show();
      });
    };

    const showFollowed = () => {
      cardTable.find("tr").each(function () {
        cardTable.find("tr").eq(0).find("th").eq(0).css({ opacity: 0.2 });
        cardTable.find("tr").eq(0).find("th").eq(1).css({ opacity: 1 });
        $(this).find("td").hide();
        $(this).find("td").eq(0).show();
        $(this).find("td").eq(3).show();
        $(this).find("td").eq(4).show();
      });
    };

    showNormal();

    cardTable.find("tr").eq(0).find("th").eq(0).on("click", showNormal);
    cardTable.find("tr").eq(0).find("th").eq(1).on("click", showFollowed);
  }

  loadPriceModule();
});

async function loadPriceModule() {
  if (!$("#oneShootLetter").length) {
    return;
  }
  await loadCountries();
  await loadPrice();

  $("#oneShootLetterSubmit").on("click", loadPrice);
}

async function loadCountries(options) {
  options = Object.assign({ retry: 0 }, options)
  try {
    const $select = $("#oneShootLetterCountry");
    if (!$select.length) return;

    const response = await fetch("/api/mail/country");
    const countries = await response.json();

    if (!response.ok) {
      console.error(countries.message);
    }

    $select.append(
      $("<option/>", {
        value: "",
        text: $select.data("placeholder"),
        selected: true,
        disabled: true,
      })
    );

    $.each(countries, function (index, value) {
      $select.append(
        $("<option/>", {
          value: value.code,
          text: value.label,
        })
      );
    });
  } catch (error) {
    if (options.retry < 10) {
      options.retry++;
      return loadCountries(options)
    }
    console.error(error)
  }
}

async function loadPrice(options) {
  options = Object.assign({ retry: 0 }, options)

  let country = $("#oneShootLetterCountry").val();
  let pageCount = $("#oneShootLetterPageCount").val();

  const $normalCell = $("#oneShootLetter").find(".offer-oneshoot-price").eq(1);
  const $followedCell = $("#oneShootLetter")
    .find(".offer-oneshoot-price")
    .eq(3);
  const $recommendedCell = $("#oneShootLetter")
    .find(".offer-oneshoot-price")
    .eq(5);

  if (!country || !country.length) {
    country = "FR";
  }

  if (!pageCount || !pageCount.length) {
    pageCount = 1;
  }

  $normalCell.html(generateLoader());
  $followedCell.html(generateLoader());
  $recommendedCell.html(generateLoader());

  try {
    const response = await fetch(
      `/api/mail/price?country=${country}&pageCount=${pageCount}`
    );
    const price = await response.json();

    $normalCell.html(formatPrice(price.normal.price));
    $followedCell.html(formatPrice(price.followed.price));
    $recommendedCell.html(formatPrice(price.recommended.price));
  } catch (error) {
    if (options.retry < 10) {
      options.retry++;
      return loadPrice(options)
    }
    console.error(error)
  }
}

function generateLoader() {
  return '<div class="text-center"><div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div></div>';
}

function formatPrice(price) {
  const country = $('body').data('country')
  if(country === 'gb') return `£${Number(price).toFixed(2)}`;
  return `${`${Number(price).toFixed(2)}`.replace(".", ",")}€`;
}
